module.exports = __webpack_public_path__ + "static/bellclick1.b1b5e2c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/bellclick1.jpg
// module id = 1255
// module chunks = 35783957827783